<template>
    <div class="modal hide fade in" id="modalSolicitud" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detalles de la Solicitud: # {{Solicitudes.SolicitudDocumentoId}}, Fecha de Solicitud: {{this.FechaConFormato(Solicitudes.FechaRegistro)}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            
                <div v-if="Solicitudes.Juzgado != null">
                    <div>
                        <h6>Solicitante del Poder Judicial</h6>
                        <hr>
                    </div>
                    <div class="row">
                        <div class="form-group col-4" id="Nombre_div" v-if="Solicitudes.Juzgado.UsuarioIdQuienSolicita != null">
                            <label>Nombre</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Juzgado.UsuarioIdQuienSolicita.Nombre"/>
                        </div>
                        <div class="form-group col-4" id="Nombre_div" v-else>
                            <label>Nombre</label>
                            <input type="text" class="form-control" readonly/>
                        </div>

                        <div class="form-group col-4" id="ApPaterno_div" v-if="Solicitudes.Juzgado.UsuarioIdQuienSolicita!= null">
                            <label>Apellido Paterno</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno"/>
                        </div>
                        <div class="form-group col-4" id="ApPaterno_div" v-else>
                            <label>Apellido Paterno</label>
                            <input type="text" class="form-control" readonly />
                        </div>

                        <div class="form-group col-4" id="ApMaterno_div" v-if="Solicitudes.Juzgado.UsuarioIdQuienSolicita!= null">
                            <label>Apellido Materno</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno"/>
                        </div>
                        <div class="form-group col-4" id="ApMaterno_div" v-else>
                            <label>Apellido Materno</label>
                            <input type="text" class="form-control" readonly/>
                        </div>

                        <div class="form-group col-6" id="Area_div">
                            <label>Área</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Juzgado.AreaIdQueSolicita.Nombre"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12" id="ObsJuzgado">
                            <label>Observaciones en Juzgado</label>
                            <textarea type="text" class="form-control" readonly v-model="Solicitudes.ObservacionesJuzgado" rows="2"/>
                        </div>
                    </div>
                    
                </div>
                <div v-else>
                    <div>
                        <h6>Solicitante Público</h6>
                        <hr>
                    </div>
                    <div class="row">
                        <div class="form-group col-4" id="Nombre_div">
                            <label>Nombre</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Publica.Nombre"/>
                        </div>
                        <div class="form-group col-4" id="ApPaterno_div">
                            <label>Apellido Paterno</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Publica.ApellidoPaterno"/>
                        </div>
                        <div class="form-group col-4" id="ApMaterno_div">
                            <label>Apellido Materno</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Publica.ApellidoMaterno"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-4" id="TipoIdentificacion_div">
                            <label>Tipo de Identificación</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Publica.TipoIdentificacion.Nombre"/>
                        </div>
                        <div class="form-group col-4" id="ApPaterno_div">
                            <label>Numero de Identificación</label>
                            <input type="text" class="form-control" readonly v-model="Solicitudes.Publica.NumeroIdentificacion"/>
                        </div>
                    </div>
                    
                    <div class="row" >
                        <div class="form-group col-12" id="obsArchivo">
                            <label>Observaciones en Archivo</label>
                            <textarea type="text" class="form-control" readonly v-model="Solicitudes.ObservacionesArchivo" rows="2"/>
                        </div>
                    </div>

                </div>
                    <div v-if="Solicitudes.VolumenesEnSolicitud.length>0">
                        <h6>Tomos en la Solicitud</h6>
                        <hr>
                    </div>

                    <div id="Volumenes_table_Archivo" class="table-reponsive" v-if="AreaConsulta.Area.AreaId==21 && Solicitudes.VolumenesEnSolicitud.length>0">
                        <table class="table table-striped table-light table-hover">
                            <thead class="thead-dark">
                                <tr>
                                    <th>No.</th>
                                    <th>Fojas</th>
                                    <th>Contenedor</th>
                                    <th>Ubicación</th>
                                    <th>Contenido</th>
                                    <th>Estatus</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                              <tr v-for="Lista in Solicitudes.VolumenesEnSolicitud" :key="Lista.Volumenes.VolumenId">
                                <td width="30">{{Lista.Volumenes.NumVolumen}}</td>
                                <td width="30" class="category_enabled">
                                    <input type="number" v-model="Lista.Volumenes.Fojas" width="20px" />
                                </td>
                                <td width="30" class="category_enabled">
                                    <input type="number" v-model="Lista.Volumenes.Contenedor" width="20px"/>
                                </td>
                                <td width="100">{{Lista.Volumenes.Area.Nombre}}</td>
                                <td width="150" v-html="DesglosaContenido(Lista.Volumenes)"></td>
                                <td width="100" v-if="Lista.Volumenes.MovimientoVolumen != null && Lista.Volumenes.MovimientoVolumen.FechaRecepcion!=null ">
                                  Recibído por Usuario
                                </td>
                                <td width="50" v-else-if="Lista.Volumenes.MovimientoVolumen != null && Lista.Volumenes.MovimientoVolumen.FechaRecepcion==null">Sin Recepción</td>
                                <td width="50" v-else>En Solicitud</td>
                                <td width="50"></td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id="Volumenes_table_Juzgado" class="table-reponsive" v-if="AreaConsulta.Area.AreaId!=21 && Solicitudes.VolumenesEnSolicitud.length>0">
                        <table class="table table-striped table-light table-hover">
                            <thead class="thead-dark">
                                <tr>
                                    <th>Volumen</th>
                                    <th>Fojas</th>
                                    <th>Ubicación</th>
                                    <th>Contenido</th>
                                    <th>Usuario</th>
                                    <th>Estatus</th>
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                              <tr v-for="Lista in Solicitudes.VolumenesEnSolicitud" :key="Lista.Volumenes.VolumenId">
                                <td width="50">{{Lista.Volumenes.NumVolumen}}</td>
                                <td width="150">{{Lista.Volumenes.Fojas}}</td>
                                <td width="150">{{Lista.Volumenes.Area.Nombre}}</td>
                                <td width="150" v-html="DesglosaContenido(Lista.Volumenes)"></td>
                                <td width="200" v-if="Lista.Volumenes.MovimientoVolumen != null && Lista.Volumenes.MovimientoVolumen.UsuarioQuienRecibe!=null">
                                  {{Lista.Volumenes.MovimientoVolumen.UsuarioQuienRecibe.Nombre}}
                                  {{Lista.Volumenes.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno}}
                                  {{Lista.Volumenes.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno}}
                                </td>
                                <td width="200" v-else></td>
                                <td width="150" v-if="Lista.Volumenes.MovimientoVolumen != null && Lista.Volumenes.MovimientoVolumen.FechaRecepcion!=null ">
                                  Recibído por Usuario
                                </td>
                                <td width="150" v-else-if="Lista.Volumenes.MovimientoVolumen != null && Lista.Volumenes.MovimientoVolumen.FechaRecepcion==null">Sin Recepción</td>
                                <td width="150" v-else>En Solicitud</td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div v-if="Solicitudes.IncidentesEnSolicitud.length>0">
                        <h6>Incidentes en la Solicitud</h6>
                        <hr>
                    </div>
                    <div id="Incidentes_table_Archivo" class="table-reponsive" v-if="AreaConsulta.Area.AreaId==21 && Solicitudes.IncidentesEnSolicitud.length>0">
                        <table class="table table-striped table-light table-hover">
                            <thead class="thead-dark">
                                <tr>
                                    <th>No.</th>
                                    <th>Tipo</th>
                                    <th>Contenedor</th>
                                    <th>Ubicación</th>
                                    <th>Estatus</th>
                                   <th></th>
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                              <tr v-for="Lista in Solicitudes.IncidentesEnSolicitud" :key="Lista.Incidentes.IncidenteId">
                                <td width="50">{{Lista.Incidentes.NumeroIncidente}}</td>
                                <td width="150">{{Lista.Incidentes.TipoIncidente}}</td>
                                <td width="150" class="category_enabled">
                                    <input type="number" v-model="Lista.Incidentes.Contenedor" />
                                </td>
                                <td width="200">{{Lista.Incidentes.Area.Nombre}}</td>
                                
                                
                                <td width="150" v-if="Lista.Incidentes.MovimientoIncidente != null && Lista.Incidentes.MovimientoIncidente.FechaRecepcion!=null ">
                                  Recibído por Usuario
                                </td>
                                <td width="100" v-else>Sin Recepción</td>
                                
                                <td width="100"></td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id="Incidentes_table_Juzgado" class="table-reponsive" v-if="AreaConsulta.Area.AreaId!=21 && Solicitudes.IncidentesEnSolicitud.length>0">
                        <table class="table table-striped table-light table-hover">
                            <thead class="thead-dark">
                                <tr>
                                    <th>No.</th>
                                    <th>Tipo</th>
                                    <th>Ubicación</th>
                                    <th>Usuario</th>
                                    <th>Estatus</th>
                                    
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                              <tr v-for="Lista in Solicitudes.IncidentesEnSolicitud" :key="Lista.Incidentes.IncidenteId">
                                <td width="50">{{Lista.Incidentes.NumeroIncidente}}</td>
                                <td width="150">{{Lista.Incidentes.TipoIncidente}}</td>
                    
                                <td width="200">{{Lista.Incidentes.Area.Nombre}}</td>
                                <td width="250" v-if="Lista.Incidentes.MovimientoIncidente != null && Lista.Incidentes.MovimientoIncidente.UsuarioQuienRecibe!=null">
                                  {{Lista.Incidentes.MovimientoIncidente.UsuarioQuienRecibe.Nombre}}
                                  {{Lista.Incidentes.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno}}
                                  {{Lista.Incidentes.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno}}
                                </td>
                                <td width="250" v-else></td>
                                <td width="150" v-if="Lista.Incidentes.MovimientoIncidente != null && Lista.Incidentes.MovimientoIncidente.FechaRecepcion!=null ">
                                  Recibído por Usuario
                                </td>
                                <td width="100" v-else-if="Lista.Incidentes.MovimientoIncidente != null && Lista.Incidentes.MovimientoIncidente.FechaRecepcion==null">Sin Recepción</td>
                                <td width="100" v-else>En Solicitud</td>
                                
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="Solicitudes.TerceriasEnSolicitud.length>0">
                        <h6>Tercerías en la Solicitud</h6>
                        <hr>
                    </div>
                    <div id="Tercerias_table_Archivo" class="table-reponsive" v-if="AreaConsulta.Area.AreaId==21 && Solicitudes.TerceriasEnSolicitud.length>0">
                        <table class="table table-striped table-light table-hover">
                            <thead class="thead-dark">
                                <tr>
                                    <th>No.</th>
                                    <th>Tipo</th>
                                    <th>Ubicación</th>
                                    <th>Estatus</th>
                                    
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                              <tr v-for="Lista in Solicitudes.TerceriasEnSolicitud" :key="Lista.Tercerias.TerceriaId">
                                <td width="50">{{Lista.Tercerias.NumeroTerceria}}</td>
                                <td width="150">{{Lista.Tercerias.TipoTerceria}}</td>
                    
                                <td width="200">{{Lista.Tercerias.Area.Nombre}}</td>
                                
                                <td width="150" v-if="Lista.Tercerias.MovimientoTerceria != null && Lista.Tercerias.MovimientoTerceria.FechaRecepcion!=null ">
                                  Recibído por Usuario
                                </td>
                                <td width="100" v-else-if="Lista.Tercerias.MovimientoTerceria != null && Lista.Tercerias.MovimientoTerceria.FechaRecepcion==null">Sin Recepción</td>
                                <td width="100" v-else>En Solicitud</td>
                                
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id="Tercerias_table_Juzgado" class="table-reponsive" v-if="AreaConsulta.Area.AreaId!=21 && Solicitudes.TerceriasEnSolicitud.length>0">
                        <table class="table table-striped table-light table-hover">
                            <thead class="thead-dark">
                                <tr>
                                    <th>No.</th>
                                    <th>Tipo</th>
                                    <th>Ubicación</th>
                                    <th>Usuario</th>
                                    <th>Estatus</th>
                                    
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                              <tr v-for="Lista in Solicitudes.TerceriasEnSolicitud" :key="Lista.Tercerias.TerceriaId">
                                <td width="50">{{Lista.Tercerias.NumeroTerceria}}</td>
                                <td width="150">{{Lista.Tercerias.TipoTerceria}}</td>
                    
                                <td width="200">{{Lista.Tercerias.Area.Nombre}}</td>
                                <td width="250" v-if="Lista.Tercerias.MovimientoTerceria != null && Lista.Tercerias.MovimientoTerceria.UsuarioQuienRecibe!=null">
                                  {{Lista.Tercerias.MovimientoTerceria.UsuarioQuienRecibe.Nombre}}
                                  {{Lista.Tercerias.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno}}
                                  {{Lista.Tercerias.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno}}
                                </td>
                                <td width="250" v-else></td>
                                <td width="150" v-if="Lista.Tercerias.MovimientoTerceria != null && Lista.Tercerias.MovimientoTerceria.FechaRecepcion!=null ">
                                  Recibído por Usuario
                                </td>
                                <td width="100" v-else-if="Lista.Tercerias.MovimientoTerceria != null && Lista.Tercerias.MovimientoTerceria.FechaRecepcion==null">Sin Recepción</td>
                                <td width="100" v-else>En Solicitud</td>
                                
                              </tr>
                            </tbody>
                        </table>
                    </div>
                
            
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-dark" id="botonAceptar" data-dismiss="modal">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    data(){
        return{
            AreaConsulta:{
                Area:{
                    AreaId:0
                }
            }
        }
    },
    props:{
        Solicitudes: {}
    },
    methods: {
        Mostrar: function () {
        $('#modalSolicitud').modal('show');
        $('#closeModal').unbind('click').click(this.ModalClose);
        $('#botonAceptar').unbind('click').click(this.ModalClose);
      },
      ModalClose: function(){
            $('#modalSolicitud').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', false);
      },
      DesglosaContenido: function (datos){
            let Contenido ="";
            
            if(datos.Amparos!=null && datos.Amparos.length>0)
            {
              Contenido= Contenido +"<b class='text-primary'>AMPAROS</b><br/>";
                    $.each(datos.Amparos, function(index, enVolumen)
                    {
                    Contenido = Contenido + "Consecutivo: "+ enVolumen.AmparosDelDocumento.Consecutivo + "/" + enVolumen.AmparosDelDocumento.Anio + "<br/>";
                    })
            };
            if(datos.IncidenteVolumen!=null && datos.IncidenteVolumen.length>0)
                {
                  Contenido = Contenido +"<b class='text-primary'>INCIDENTES</b><br/>";
                    $.each(datos.IncidenteVolumen, function(index, enVolumen)
                    {
                    Contenido = Contenido + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                    })
                }
            return Contenido;
        },
        FechaConFormato(fecha)
        {
            return moment(fecha).format('DD/MM/YYYY');
        }
    },
    mounted(){
        this.AreaConsulta = this.$store.state.Login_Usuario;
        this.Mostrar();
    }
}
</script>
<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }
input[type="text"]:read-only:focus {
      color: #fff;
    }
textarea[type="text"]:read-only {
    background: #504f54;
  }    
textarea[type="text"]:read-only:focus {
      color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/DetalleSolicitud.vue